<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="메뉴관리">
          <!-- <b-form-group label-cols="2" horizontal label="메인 이미지" class="weight600"> -->
          <div class="form-horizontal">
            <div class="table-responsive p-0" style="margin-top:10px">
              <b-table id="table-transition-example" :items="list" :fields="fields" striped small class="text-center" primary-key="menuCode" :tbody-transition-props="transProps">
                <template v-slot:cell(menuName)="row" class="text-center">
                    <span class="cls_click" @click="menunameClickEve(row.item,row.item.menuCode)">
                      <a class="cls_click">
                      {{ row.item.menuName }}
                      </a>
                    </span>
                </template>

                <template v-slot:cell(listPrice)="row" class="text-center">
                      {{ row.item.listPrice | numFormat }}
                </template>

                <template v-slot:cell(mainMenu)="row" class="text-center">
                  <div class="linkcmp text-center" style="display: inline-flex;width:100%;justify-content: center;"
                       @click="onChangeStatus(row.item.mainMenu, row.index,row.item.menuCode)">
                    <ToggleBtn :value="row.item.mainMenu"/>
                  </div>
                </template>

                <template v-slot:cell(registeredDate)="row" class="text-center">
                  {{ viewDate(row.item.registeredDate) }}
                </template>

                <template v-slot:cell(sortNumber)="row" class="text-center">
                  <b-button-group vertical p-0>
                    <b-button variant="empty" class="header-icon btn-sm p-0"
                              @click="moveUpItem(row.item, row.index , row.item.menuCode , $event.target  )"
                              :disabled="row.index <= 0">
                      <b-icon icon="chevron-up" font-scale="1.5"></b-icon>
                    </b-button>
                    <b-button variant="empty" class="header-icon btn-sm p-0"
                              @click="moveDownItem(row.item, row.index , row.item.menuCode , $event.target )"
                              :disabled="row.index >= (list.length - 1)">
                      <b-icon icon="chevron-down" font-scale="1.5"></b-icon>
                    </b-button>
                  </b-button-group>
                </template>

                <template v-slot:cell(delete)="row" class="text-center">
                  <button type="button" class="btn btn-social-icon" @click="delmenulist(row.index,row.item.menuCode)">
                    <b-icon-trash></b-icon-trash>
                  </button>
                </template>

              </b-table>

            </div>
            <div class="right-btn">
              <button type="button" class="btn top-right-button btn-outline-success right-btn" @click="menuListAdd">메뉴
                만들기
              </button>
            </div>
          </div>
          <!-- </b-form-group> -->
        </b-card>
        <!-- 메뉴 모달 -->
        <div class="modal" :style="showmenumodal && {'display': 'block'}">
          <div class="modal-dialog maxwid">
            <div class="modal-content">
              <div class="modal-header">{{ menuModalName }}</div>
              <div class="modal-body form-horizontal">
                <div class="form-group">
                  <div class="divbox">
                    <div class="col-sm-2">메뉴명 *</div>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="Mmenuname" maxlength="30">
                    </div>
                  </div>
                  <div class="mt-2 divbox">
                    <div class="col-sm-2">메뉴설명</div>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="Mmenuinfo">
                    </div>
                  </div>
                  <div class="mt-2 divbox">
                    <div class="col-sm-2">정상가 *</div>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="Mmenuprice" style="max-width: 200px;"
                             @input="e=>Mmenuprice=changeNum(e.target.value)">
                      <span>원</span>
                    </div>
                  </div>
                  <div class="mt-2 divbox">
                    <div class="col-sm-2">기준인원 *</div>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="Mmenuperson" style="max-width:200px;"
                             @input="e=>Mmenuperson=changeNum(e.target.value)">
                      <span>명</span>
                    </div>
                  </div>
                  <div class="mt-2 divbox">
                    <div class="col-sm-2">메뉴 이미지</div>
                    <div class="col-sm-9">
                      <div v-for="(simg, sidx) in menuUnitDto.menuImages" :key="sidx" class="imglist"
                           style="margin-right:5px">
                        <!-- {{  simg }} -->
                        <drop @drop="sumimagesort(sidx, $event)" v-if="simg.length > sidx ||  simg">
                          <drag :transfer-data="{ index: sidx, mark:'subimgs' }">
                            <NewProdImg :value="simg.images.url" :index="sidx" :change="onRmvSubImg"/>
                          </drag>
                        </drop>

                      </div>
                      <div class="imglist">
                        <NewProdImg :index="menuUnitDto.menuImages.length" value :change="onmenuAdminList"
                                    ref="prodimg"/>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer text-center">
                <button type="button" class="btn btn-outline-primary" @click="closeMenumodal">닫기</button>
                <button type="button" class="btn btn-default btn-primary" @click="saveMenuList('save')"
                        v-if="this.menuModalName === '메뉴 만들기'">저장
                </button>
                <button type="button" class="btn btn-default btn-primary" @click="saveMenuList('edit')" v-else>수정
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 메뉴 모달 end -->

      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import api from "../../constants/api";
import ToggleBtn from './ToggleBtn';
import NewProdImg from './newProdImg';
import {
  mapGetters,
  mapActions
} from "vuex";
import {
  DateFormat
} from "../../utils/index";
import {
  Drag,
  Drop
} from "vue-drag-drop";

export default {
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },
  components: {
    ToggleBtn,
    NewProdImg,
    Drag,
    Drop
  },
  data() {
    return {
      transProps: {
        name: 'list'
      },
      fields: [{
        key: 'menuCode',
        label: "메뉴코드"
      },
        {
          key: 'menuName',
          label: "메뉴명"
        },
        {
          key: 'listPrice',
          label: "정상가"
        },
        {
          key: 'headCount',
          label: "기준인원"
        },
        {
          key: 'mainMenu',
          label: "대표메뉴"
        },
        {
          key: 'registeredDate',
          label: "등록일"
        },
        {
          key: 'sortNumber',
          label: "우선 순위"
        },
        {
          key: 'delete',
          label: "삭제"
        },
      ],
      userRole: null,
      showmenumodal: false,
      menuModalName: "",
      Mmenuname: "",
      Mmenuprice: 0,
      Mmenuinfo: "",
      Mmenuperson: "",
      prodimgIdx: 0,
      list: [],
      menuCopyMenuCode: "",
      menuUnitDto: {
        menuName: "",
        description: "",
        listPrice: 0,
        headCount: 0,

        menuImages: [],

      }
    }
  },
  mounted() {
    this.userRole = this.currentUser.userRole.split('_')[0]
    this.refresh();
  },
  watch: {
    Mmenuprice(val) {
      const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/;

      // 한글, 영문 체크
      if (reg.exec(val) !== null) this.Mmenuprice = val.replace(/[^0-9]/g, '');

      // .... 만 입력하게 될 경우 체크
      if (isNaN(parseFloat(val))) this.Mmenuprice = '';
    }
  },
  methods: {
    refresh() {
      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuListBrd) + "?storeCode=" + this.$route.params.storeCode;
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuListStr)
      }
      const params = {}

      this.$http.get(reqURL, {
        params: params,
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          for (let i in res.data.data) {
            this.list = res.data.data[i]
          }
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.message);
      })
    },
    moveUpItem(item, index, optionCode, button) {
      console.log(button)
      if (index <= 0) {
        return
      }
      let preItem = this.list[index - 1];
      let clickedItem = this.list[index];
      this.list.splice(index - 1, 2, clickedItem, preItem)
      this.orderUpdate()
    },

    moveDownItem(item, index, optionCode, button) {
      if (index >= (this.list.length - 1)) {
        return
      }
      let postItem = this.list[index + 1];
      let clickedItem = this.list[index];
      this.list.splice(index, 2, postItem, clickedItem)
      this.orderUpdate()
    },
    orderUpdate() {
      const sortNumberList = [];
      let priority = 1;
      console.log(this.list)
      this.list.forEach(function (value, index) {
        sortNumberList.push({
          menuId: value.menuCode,
          sortNumber: priority++
        })
      })

      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuNumberUpdateBrd)
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuNumberUpdateStr)
      }

      const params = {
        sortNumberList: sortNumberList,
        storeCode: this.$route.params.storeCode
      }
      // console.log(params)
      this.$http.post(reqURL, params, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          // alert('적용되었습니다.')
          this.$emit('get-kakao-alert', 'STORE');
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    viewDate(val) {
      return DateFormat(val, "YYYY-MM-DD");
    },
    menuListAdd() {
      this.showmenumodal = true;
      this.menuModalName = "메뉴 만들기";
      this.Mmenuname = '';
      this.Mmenuprice = 0;
      this.Mmenuinfo = '';
      this.Mmenuperson = '';
      this.menuUnitDto.menuImages = [];
    },
    delmenulist(idx, menuCode) {
      if (confirm("삭제하시겠습니까? 예약관리에 해당메뉴로 생성된 옵션 및 예약시간에 연결된 옵션 모두 삭제됩니다.")) {
        let params = {};
        let reqURL = '';
        if (this.userRole == "BRAND") {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuDeleteBrd)
          params = {
            storeCode: this.$route.params.storeCode,
            menuCode: menuCode,
          }
        } else {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuDeleteStr)
          params = {
            menuCode: menuCode,
          }
        }

        this.$http.post(reqURL, params, {
          headers: {
            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
          }
        }).then(res => {
          if (res.data.code === "OK") {
            this.$emit('get-kakao-alert', 'STORE');
            this.refresh();

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }
    },
    closeMenumodal() {
      this.Mmenuname = '';
      this.Mmenuprice = 0;
      this.Mmenuinfo = '';
      this.Mmenuperson = '';
      this.menuUnitDto.menuImages = [];
      this.showmenumodal = false;
    },
    saveMenuList(type) {
      let reqURL = ''
      if (this.Mmenuname === "") {
        alert('메뉴명을 입력해주세요.');
        return;
      }
      if (this.Mmenuprice === "") {
        alert('정상가를 입력해주세요.');
        return;
      }
      if (this.Mmenuperson === "") {
        alert('기준인원을 입력해주세요.');
        return;
      }
      let menuparmat = {},
        alertText = "";
      let menuUnitDtos = this.menuUnitDto;
      menuUnitDtos.menuName = this.Mmenuname;
      menuUnitDtos.description = this.Mmenuinfo;
      if (Number(this.Mmenuprice) !== 0) {
        menuUnitDtos.listPrice = this.Mmenuprice.replace(/,/gi, '');
      }
      menuUnitDtos.headCount = this.Mmenuperson;
      if (type === 'save') {
        if (this.userRole == "BRAND") {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuCreateBrd);
          menuparmat = {
            menuUnitDto: menuUnitDtos,
            storeCode: this.$route.params.storeCode
          }
        } else {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuCreateSrt);
          menuparmat = {
            menuUnitDto: menuUnitDtos,
          }
        }
        alertText = '메뉴가 등록 되었습니다.';
        this.showmenumodal = false;
      } else {

        if (this.userRole == "BRAND") {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuUpdateBrd);
          menuparmat = {
            menuUnitDto: menuUnitDtos,
            storeCode: this.$route.params.storeCode,
            menuCode: this.menuCopyMenuCode,
          }
        } else {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuUpdateSrt);
          menuparmat = {
            menuUnitDto: menuUnitDtos,
            menuCode: this.menuCopyMenuCode,
          }
        }
        alertText = '메뉴가 수정 되었습니다.';
        this.showmenumodal = false;
      }

      this.$http.post(reqURL, menuparmat, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          alert(alertText);
          this.$emit('get-kakao-alert', 'STORE');
          this.refresh();

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    onChangeStatus(mainMenu, midx, menuCode) {
      var reqURL = '';
      if (!mainMenu) {
        if (this.userRole == "BRAND") {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuEnableBrd)
        } else {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuEnableStr)
        }
      } else {
        if (this.userRole == "BRAND") {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuDisableBrd)
        } else {
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuDisableStr)
        }
      }
      const params = {
        storeCode: this.$route.params.storeCode,
        menuCode: menuCode,
      }

      this.$http.post(reqURL, params, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          this.list[midx].mainMenu = !mainMenu;
          this.$emit('get-kakao-alert', 'STORE');
          this.refresh();
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    onmenuAdminList(idx, url, width, height) {
      let description = this.Mmenuinfo;
      this.prodimgIdx = idx;
      let menuUnitDtoLastIdx = '';
      if (this.menuUnitDto.menuImages.length !== 0) {
        menuUnitDtoLastIdx = this.menuUnitDto.menuImages[this.menuUnitDto.menuImages.length - 1].displayOrder;
      } else {
        menuUnitDtoLastIdx = idx;
      }
      this.menuUnitDto.menuImages.push({
        displayOrder: menuUnitDtoLastIdx + 1,
        images: {
          url,
          width,
          height,
          description,
        }
      });
      // console.log(this.menuUnitDto.menuImages)
    },
    onRmvSubImg(idx) {
      this.menuUnitDto.menuImages.splice(idx, 1);
    },
    sumimagesort(drop, drag) {
      if (drag !== undefined) {
        if (drag.mark != 'subimgs') {
          return;
        }
        var t_array = this.menuUnitDto.menuImages;
        this.menuUnitDto.menuImages = [];

        var b = t_array[drag.index];
        t_array[drag.index] = t_array[drop];

        let newTrp = JSON.parse(JSON.stringify(t_array[drop].displayOrder)); //드래그해서 움직일 tr에 displayOrder
        let existingTr = JSON.parse(JSON.stringify(b.displayOrder)); //기존위치에 tr에 displayOrder
        console.log(existingTr);
        console.log(newTrp);

        b.displayOrder = newTrp; // displayOrder 변경
        t_array[drag.index].displayOrder = existingTr; //드래그 한 tr displayOrder 변경

        t_array[drop] = b;
        this.menuUnitDto.menuImages = t_array;
        console.log(this.menuUnitDto.menuImages)
      }
    },
    menunameClickEve(idx, menuCode) {

      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuQueryBrd) + "?storeCode=" + this.$route.params.storeCode + "&menuCode=" + menuCode
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeMenuQueryStr) + "?menuCode=" + menuCode
      }
      const params = {}

      this.$http.get(reqURL, {
        params: params,
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          this.showmenumodal = true;
          this.menuModalName = "메뉴 상세";
          this.Mmenuname = res.data.data.menuName;
          this.Mmenuprice = res.data.data.listPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.Mmenuinfo = res.data.data.description;
          this.Mmenuperson = res.data.data.headCount;
          this.menuUnitDto.menuImages = res.data.data.menuImages;
          this.menuCopyMenuCode = menuCode;
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.message);
      })

    },
    bindNumber(event) {
      this.Mmenuprice = event.target.value;
    },
    changeNum: function (value) {
      return value = this.comma(this.uncomma(value));
    },
    comma(str) {
      str = String(str);
      return str.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    },
    uncomma(str) {
      str = String(str);
      return str.replace(/[^\d]+/g, '');
    }

  }
}
</script>

<style scoped>
.mt-2 {
  margin-top: 20px;
}

.divbox {
  min-height: 34px;
  display: block;
}

.divbox > div > input {
  display: inline-block;
}

.imglist {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
  position: relative;
  border: 2px dashed #aaa;
  text-align: center;
  -webkit-transition: all .6s;
  transition: all .6s;
  padding: 2px;
}

.imglistdiv {
  display: inline-block;
  vertical-align: middle;
}

.right-btn {
  text-align: right;
}

th {
  background-color: #dee2e685;
}

.list-move {
  transition: transform 1s;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to

  /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.table>thead>tr>th {
  height: 50px;
  vertical-align: middle;
}

.table>tbody>tr>td {
  vertical-align: middle;
}

#colored {
  color: blue;
}
</style>
